import React from "react";

import InfoModal from "../modals/InfoModal";
import snoozerIcon from "../../../public/snoozer.png";

function Header() {
  return (
    <header>
      <h1 className="font-serif font-bold tracking-tight">
        <img src={snoozerIcon} alt="" className="header-icon" />
        Snoozer&#8217;s Secret Game
      </h1>
    </header>
  );
}

export default Header;
